'use strict';

/**
 * To keep app session alive
 */
function keepAppSessionAlive() {
    var isAppSession = $('#app-session').val();
    if (isAppSession === 'true') {
        var url = $('#app-session-alive-url').val();
        var interval = $('#app-session-alive-interval').val();
        if (url && interval) {
            setInterval(function () { $.get(url); }, parseInt(interval, 10));
        }
    }
}

module.exports = function () {
    // to keep app session alive
    $(document).ready(function () {
        keepAppSessionAlive();
    });
};
